import { render, staticRenderFns } from "./BarGraph.vue?vue&type=template&id=00cd4687&scoped=true&"
import script from "./BarGraph.vue?vue&type=script&lang=js&"
export * from "./BarGraph.vue?vue&type=script&lang=js&"
import style0 from "./BarGraph.vue?vue&type=style&index=0&id=00cd4687&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cd4687",
  null
  
)

export default component.exports